App.constant('Config', angular.copy(CONFIGURATOR.CORE));
App.constant('Configurator', angular.copy(CONFIGURATOR));
